import {
  getRating,
  getRatingCount,
  getGlowingWords,
  getCityAnchorTag,
  getGlowingWordsString,
  getPhoneString,
  getNextOpenDayInfo,
  getNumDaysOpenString,
  getClinicFullName,
  getCityGuideContent,
} from './util';
import { isEmptyArray } from '../../../core/util/array';
import { safeGet } from '../../../core/util/object';
import { getFullDisplayAddress } from '../../../core/util/location';
import { fromSnakeCaseToSpaces, isEmptyString } from '../../../core/util/string';
import { getCdpTitle } from '../../../core/util/seo';
import { CDP_INFO_DESCRIPTION, getCustomization } from '../util/customization';

export default class BaseFactory {
  constructor(location, properties) {
    const userAgent = safeGet(properties)('userAgent');
    this.location = location;
    this.clinicName = getClinicFullName(location);
    this.zip = location.zipCode;
    this.city = location.city;
    this.state = location.state;
    this.cityAnchorTag = getCityAnchorTag(location);

    const categories = safeGet(location, [])('category');
    const firstCategory = isEmptyArray(categories) ? '' : categories[0];
    this.clinicalCategory = fromSnakeCaseToSpaces(firstCategory);

    this.address = !isEmptyString(location.displayAddress)
      ? location.displayAddress
      : location.address;
    this.fullAddress = getFullDisplayAddress(location);

    this.rating = getRating(location);
    this.ratingCount = getRatingCount(location);

    this.phoneString = getPhoneString(location);
    this.glowingWords = getGlowingWords(location);
    this.glowingWordsString = getGlowingWordsString(location);

    const nextOpenDayInfo = getNextOpenDayInfo(location);
    this.nextOpenDayName = nextOpenDayInfo.name;
    this.nextOpenDayHoursStr = nextOpenDayInfo.openHoursString;
    this.numDaysOpenString = getNumDaysOpenString(location);
    this.title = getCdpTitle(location);
    this.cityGuideContent = getCityGuideContent(location, userAgent);
    this.isLinkable = getCustomization(CDP_INFO_DESCRIPTION, {
      location,
      userAgent,
    }).shouldBeLinkable;
  }

  getTitle() {
    return this.title;
  }
}
